import { type ReactNode } from 'react';
import { pctOf, type TodayBounds } from '../utils/today-count';

function Fill({
  todayPct,
  minPct,
}: {
  todayPct: number;
  minPct: number;
}): ReactNode {
  return (
    <div className="relative h-1.5 w-full rounded-full bg-white/[0.06]">
      <div
        className="absolute inset-y-0 left-0 rounded-full bg-text-primary/20"
        style={{ width: `${minPct}%` }}
      />
      <div
        className="absolute inset-y-0 left-0 rounded-full bg-brand-red transition-all"
        style={{ width: `${todayPct}%` }}
      />
    </div>
  );
}

function MinMarker({
  bounds,
  reached,
}: {
  bounds: TodayBounds;
  reached: boolean;
}): ReactNode {
  const cls = reached ? 'text-success' : 'text-brand-red';
  const line = reached ? 'bg-success' : 'bg-brand-red';
  return (
    <div
      className="absolute -top-0.5 flex -translate-x-1/2 flex-col items-center"
      style={{ left: `${pctOf(bounds.dailyMin, bounds.scale)}%` }}
    >
      <div className={`h-2.5 w-0.5 rounded-full ${line}`} />
      <span
        className={`mt-0.5 whitespace-nowrap text-[9px] font-semibold ${cls}`}
      >
        Min {bounds.dailyMin}
      </span>
    </div>
  );
}

export function TodayBar({
  today,
  bounds,
}: {
  today: number;
  bounds: TodayBounds;
}): ReactNode {
  return (
    <div className="relative pb-4">
      <Fill
        todayPct={pctOf(today, bounds.scale)}
        minPct={pctOf(bounds.dailyMin, bounds.scale)}
      />
      <MinMarker bounds={bounds} reached={today >= bounds.dailyMin} />
    </div>
  );
}
